import {
  AboutIcon,
  AddIcon,
  ArchiveIcon,
  ArrowDown,
  ArrowUp,
  Attachment,
  CalendarIcon,
  CancelSendIcon,
  ChartIcon,
  ChatIcon,
  Checkmark,
  ChevronDown,
  CloseIcon,
  Color,
  CopyFile,
  CopyIcon,
  DashboardIcon,
  EditIcon,
  EntryIcon,
  EyeClosedIcon,
  EyeIcon,
  FileIcon,
  FlagIcon,
  GlobeIcon,
  GroupIcon,
  HistoryIcon,
  HomeIcon,
  LeftChevron,
  ListIcon,
  LetterA,
  MeetingIcon,
  MeetingRoom,
  MessageIcon,
  MoreTimeIcon,
  NotificationIcon,
  OpenInNew,
  PersonIcon,
  Profile,
  ProjectIcon,
  QuestionAnswerIcon,
  QuestionMarkIcon,
  RedoIcon,
  RemoveIcon,
  RightArrowIcon,
  SaveIcon,
  ScheduleIcon,
  SearchIcon, 
  SendIcon,
  Settings,
  TagIcon,
  TelephoneIcon,
  TrashIcon,
  TuneIcon, 
  UnlinkIcon,
  WatchIcon,
  WorkIcon,
  analyticsIcon, 
  fileUpload,
  logOut,
  Split,
} from "assets/svg";
import { ConnectIcon } from "assets/svg/connect";
import { ArrowBack } from "assets/svg/arrowBack";
import { ArrowForward } from "assets/svg/arrowForward";
import { EnglishFlag } from "assets/svg/england";
import { LocationIcon } from "assets/svg/location";
import { ReplyIcon } from "assets/svg/reply";
import { StyleIcon } from "assets/svg/style";
import { SwedishFlag } from "assets/svg/sweden";
import { TranslateIcon } from "assets/svg/translate";
import React, { FC } from "react";
import styled, { css } from "styled-components";
import { theme } from "../config/theme";
import { DangerousIcon } from "assets/svg/dangerous";
import { DurationIcon } from "assets/svg/duration";
import { MoreIcon } from "assets/svg/more";
import { PlayIcon } from "assets/svg/play";
import { ReceiveIcon } from "assets/svg/incoming";
import { dispatchIcon } from "assets/svg/dispatch";
import { MenuIcon } from "assets/svg/menu";
import { PeopleIcon } from "assets/svg/users";
import { Filter } from "assets/svg/filter";
import { CriticalIcon } from "assets/svg/critical";
import { NewIcon } from "assets/svg/new";
import { NoneIcon } from "assets/svg/horizontalRule";
import { DocumentIcon } from "assets/svg/document";
import { ImageIcon } from "assets/svg/picture";
import { ChevronUp } from "assets/svg/chevronUp";
import { ExcelIcon } from "assets/svg/excel";
import { PdfIcon } from "assets/svg/pdf";
import { ChevronRight } from "assets/svg/ChevronRight";
import { CirclePlayIcon } from "assets/svg/playCircle";
import { PauseIcon } from "assets/svg/pause";
import { SkipNextIcon } from "assets/svg/skipNext";
import { SkipPrevIcon } from "assets/svg/skipPrev";
import { PercentageIcon } from "assets/svg/percentage";
import { DragIcon } from "assets/svg/drag";

export const icons = {
  about:              AboutIcon,
  add:                AddIcon,
  analytics:          analyticsIcon,
  archive:            ArchiveIcon,
  arrowBack:          ArrowBack,
  arrowDown:          ArrowDown,
  arrowForward:       ArrowForward,
  arrowUp:            ArrowUp,
  attachment:         Attachment,
  calendar:           CalendarIcon,
  cancel_send:        CancelSendIcon,
  chart:              ChartIcon,
  chat:               ChatIcon,
  checkmark:          Checkmark,
  chevronDown:        ChevronDown,
  chevronUp:          ChevronUp,
  close:              CloseIcon,
  color:              Color,
  connect:            ConnectIcon,
  copy:               CopyIcon,
  copyFile:           CopyFile,
  critical:           CriticalIcon,
  dangerous:          DangerousIcon,
  dashboard:          DashboardIcon,
  delete:             TrashIcon,
  dispatch:           dispatchIcon,
  document:           DocumentIcon,
  duration:           DurationIcon,
  edit:               EditIcon,
  english:            EnglishFlag,
  entry:              EntryIcon,
  eye:                EyeIcon,
  eyeClosed:          EyeClosedIcon,
  file:               FileIcon,
  fileUpload:         fileUpload,
  filter:             Filter,
  flag:               FlagIcon,
  globe:              GlobeIcon,
  group:              GroupIcon,
  history:            HistoryIcon,
  home:               HomeIcon,
  image:              ImageIcon,
  chevronLeft:        LeftChevron,
  list:               ListIcon,
  letter_a:           LetterA,
  location:           LocationIcon,
  logOut:             logOut,
  meeting:            MeetingIcon,
  menu:               MenuIcon,
  message:            MessageIcon,
  more:               MoreIcon,
  more_time:          MoreTimeIcon,
  new:                NewIcon,
  none:               NoneIcon,
  notification:       NotificationIcon,
  openInNew:          OpenInNew,
  people:             PeopleIcon,
  person:             PersonIcon,
  play:               PlayIcon,
  profile:            Profile,
  project:            ProjectIcon,
  question:           QuestionMarkIcon,
  questionAnswerIcon: QuestionAnswerIcon,
  receive:            ReceiveIcon,
  redo:               RedoIcon,
  remove:             RemoveIcon,
  reply:              ReplyIcon,
  rightArrow:         RightArrowIcon,
  room:               MeetingRoom,
  save:               SaveIcon,
  schedule:           ScheduleIcon,
  search:             SearchIcon,
  send:               SendIcon,
  settings:           Settings,
  style:              StyleIcon,
  swedish:            SwedishFlag,
  tag:                TagIcon,
  telephone:          TelephoneIcon,
  translate:          TranslateIcon,
  tune:               TuneIcon,
  unlink:             UnlinkIcon,
  watch:              WatchIcon,
  work:               WorkIcon,
  excel:              ExcelIcon,
  pdf:                PdfIcon,
  chevronRight:       ChevronRight,
  circlePlayIcon:     CirclePlayIcon,
  pause:              PauseIcon,
  skipNext:           SkipNextIcon,
  skipPrev:           SkipPrevIcon,
  percentage:         PercentageIcon,
  drag:               DragIcon,
  split:              Split,
};

const iconSizes = {
  xxsmall: "1rem",
  xsmall: "1.2rem",
  small: "1.4rem",
  medium: "1.8rem",
  large: "2.2rem",
  xlarge: "2.8rem",
  xxlarge: "3.2rem",
  default: "2rem"
};



export type IconId = keyof typeof icons;

type IconSizes = "small" | "default" | "xxsmall" | "xsmall" | "medium" | "large" | "xlarge" | "xxlarge";

type IconProps = {
  iconId: IconId;
  className?: string;
  disabled?: boolean;
  size?: IconSizes;
  label?: string;
  onClick?: (e?: any) => void;
  alternateFill?: string;
};

export const Icon: FC<IconProps & React.SVGProps<SVGSVGElement>> = React.forwardRef(({
  iconId,
  size = "small",
  label,
  disabled,
  onClick: onClick,
  className = "",
  ...rest
}, ref) => {
  const IconComponent = icons[iconId];
  const iconSize      = iconSizes[size];
  if (!IconComponent) return null;
  return (
    <IconContainer disabled={disabled} className={className} onClick={onClick}>
      <IconComponent width={iconSize} height={iconSize} {...rest} ref={ref} />
      {!!label && <IconLabel disabled={disabled}>{label}</IconLabel>}
    </IconContainer>
  );
});

const IconLabel = styled.span<{disabled: boolean}>`
  font-weight: ${theme.font.weight.normal};
  font-size: ${theme.font.size.small};
  margin-left: 0.4rem;
  cursor: pointer;
  ${(props) =>
    props.disabled && css`color: ${theme.color.disabled};`};
`;

const IconContainer = styled.span<{disabled: boolean}>`
  /* z-index: 100; */
  display: flex;
  flex-direction: row;
  align-items: center;

  ${(props) =>
    props.disabled && css`color: ${theme.color.disabled};`};
  ${(props) =>
    props.onClick && css`cursor: pointer`};

  :nth-child(2n) {
    padding-left: 0.5rem;
  }
`;
